import React from "react";
import './SubcuentaDistribucionList.css';

function SubcuentaDistribucionList({ subcuentas = [], distribucionKey, distribucionSelected }) {

    return (
        <div className={`subcuentaDistribucionListDiv ${!(distribucionKey === distribucionSelected) ? 'inactive' : ''}`}>
            {subcuentas.length > 0 ? (
                <table className="subcuenta-dist-table">
                    <thead>
                        <tr>
                            <th>Nro. Item</th>
                            <th>Dim. Sub</th>
                            <th>Subcuenta</th>
                            <th>Porcentaje</th>
                        </tr>
                    </thead>
                    <tbody>
                        {subcuentas.map((sub, index) => (
                            <tr key={index}>
                                <td>{sub.nroItm}</td>
                                <td>{sub.dimSub}</td>
                                <td>{sub.subCue}</td>
                                <td>{sub.porcen != null ? `${sub.porcen}%` : '-'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <div className="subcuentaDistribucionDiv">
                    <h4>Esta distribución no contiene subcuentas.</h4>
                </div>
            )}
        </div>
    );
}

export default SubcuentaDistribucionList;
